<template>
  <div>
    <h6>Points</h6>
    <hr />
    <div class="points-section">
      <ul v-if="waypoints.length > 0">
        <li v-for="(point, index) in waypoints" :key="index">
          <div class="point-box"><div class="point-inner-box"></div></div>
          {{ point.name }}
        </li>
      </ul>
      <div v-else class="alert alert-danger">No points found!</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['waypoints']
};
</script>

<style scoped>
h6 {
  margin-bottom: 8px;
  margin-left: 9px;
  font-size: 14px;
  font-weight: 600;
}
hr {
  margin: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.points-section {
  padding: 16px 5px 0 5px;
}
.points-section ul {
  padding: 0;
  border-left: 0.5px solid #4a4a4a;
  margin: 0;
}
.points-section ul li {
  position: relative;
  list-style: none;
  display: flex;
  align-items: center;
  margin-left: -5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 19px;
}
.points-section ul li:first-child::before,
.points-section ul li:last-child::after {
  content: '';
  position: absolute;
  width: 10px;
  height: 50%;
  background: #fff;
}
.points-section ul li:first-child::before {
  top: 0;
}
.points-section ul li:last-child::after {
  bottom: 0;
}
.points-section ul li:last-child {
  margin-bottom: 0;
}
.point-box {
  width: 10px;
  height: 10px;
  background: #4a4a4a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  flex-shrink: 0;
  z-index: 5;
}
.point-inner-box {
  width: 4px;
  height: 4px;
  background: #fff;
  border-radius: 50%;
}
.alert {
  margin-bottom: 0;
}
</style>
